const nomItemLocalStorage = 'webxom-consentiment';

export const acceptarConsentimentLocalStorage = () => localStorage.setItem(nomItemLocalStorage, true);
export const obtenirConsentimentLocalStorage = () => localStorage.getItem(nomItemLocalStorage);



// WEBPACK FOOTER //
// ./src/commons/gestioConsentimentLocalStorage.js